import React, { useEffect, useState } from "react";
import "./Payment.scss";

import { FaChevronRight, FaPlus } from "react-icons/fa6";
import { IoIosArrowBack } from "react-icons/io";
import { FaScroll, FaTrash } from "react-icons/fa";
import { SlUserFollow } from "react-icons/sl";
import { HiUserAdd } from "react-icons/hi";
import { FiSearch } from "react-icons/fi";
import { LuLoader2 } from "react-icons/lu";
import { FaUserCog, FaUser } from "react-icons/fa";
import { MdSwapHorizontalCircle } from "react-icons/md";
import { FaUserAlt } from "react-icons/fa";
import { FaWallet } from "react-icons/fa";

import CustomButton from "../../../components/CustomButton/CustomButton";
import { PaymentMethods } from "../../../constants/paymentMethods";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import InputField from "../../../components/InputField/InputField";
import { useForm } from "react-hook-form";
import {
  addPaymentArray,
  clearCart,
  clearPaymentCustomerDetails,
  removeFromPaymentArray,
  updatePaymentCustomerDetails,
} from "../../../redux/features/cart-slice";
import ToggleSwitch from "../../../components/ToggleSwitch/ToggleSwitch";
import { CountryCodes } from "../../../constants/countryCodes";
import InputSelect from "../../../components/InputSelect/InputSelect";
import {
  addCustomer as addNewCustomer,
  fetchCustomers,
} from "../../../api/customers";
import { saveSale } from "../../../api/sales";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import PaymentStatus from "../PaymentStatus/PaymentStatus";
import { convertOrderToSale } from "../../../api/orders";
import useOrganizationIsAllowed from "../../../helpers/organizationPrevillages";
import { updateOpenSubscriptionAd } from "../../../redux/features/subscription-slice";
import { loadAnalytics } from "../../../redux/features/analytics-slice";
import { fetchSalesData } from "../../../redux/features/home-slice";
import {
  updateExistingProduct,
  updateLastParams,
} from "../../../redux/features/products-slice";

import Customer from "../../Customer/Customer";
import AddCustomer from "../../Customer/AddCustomer/AddCustomer";
import PDF from "../../PDF/PDF";
import {
  addNewOfflineOrder,
  addNewOrder,
  deleteExistingOrder,
} from "../../../redux/features/orders-slice";
import {
  addNewOfflineSale,
  addNewSale,
} from "../../../redux/features/sales-slice";
import { storage } from "../../../helpers/storage";
import { isActuallyOnline } from "../../../helpers/network";

const Payment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const orgIsAllowedToTakeOrders = useOrganizationIsAllowed("order");
  const orgIsAllowedForStoreCredit = useOrganizationIsAllowed(
    "return_or_store_credit"
  );

  const {
    saleId,
    items,
    totalPrice,
    cash_discount,
    percent_discount,
    tax,
    delivery_charge,
    note,
    remaining_amount,
    payment_array,
    customer_name,
    customer_number,
    customer_email,
    customer_country_code,
    customer_id,
    customer_address,
    customer_allow_pay_later,
    customer_credit_amount,
  } = useSelector((state) => state.cartReducer.value);

  const { currency, id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );

  const { id: branch_id } = useSelector((state) => state.branchReducer.value);
  const { loaded: analyticsLoaded } = useSelector(
    (state) => state.analyticsReducer
  );
  const { run } = useSelector((state) => state.tourReducer.value);
  const {
    tour_checkout,
    id: user_id,
    name: user_name,
    email: user_email,
  } = useSelector((state) => state.userReducer.value);

  useEffect(() => {
    if (items?.length <= 0 && !(run && tour_checkout)) {
      if (!status || status !== "success") {
        navigate(ROUTES.checkout.path);
      }
    }
  }, [items]);

  const [selectedTab, setSelectedTab] = useState("");
  const [status, setStatus] = useState("");
  const [saleID, setSaleID] = useState(null);

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

  const [submitting, setSubmitting] = useState(false);
  const [openPaymentList, setOpenPaymentList] = useState(false);
  const [openAddCustomer, setOpenAddCustomer] = useState(false);

  const [openDesktopAddCustomer, setOpenDesktopAddCustomer] = useState(false);
  const [openDesktopAddCustomerPage, setOpenDesktopAddCustomerPage] =
    useState(false);

  const [openAddCustomerNotifier, setOpenAddCustomerNotifier] = useState(false);

  const [successData, setSuccessData] = useState({
    totalPrice: 0,
    remainingAmount: 0,
  });

  useEffect(() => {
    setOpenDesktopAddCustomerPage(false);
  }, [customer_id]);

  useEffect(() => {
    if (status) {
      setOpenPaymentList(false);
      setOpenAddCustomerNotifier(false);
      setSelectedPaymentMethod(null);
      setOpenDesktopAddCustomer(false);
      setOpenDesktopAddCustomerPage(false);
    }
  }, [status]);

  useEffect(() => {
    if (openDesktopAddCustomer) {
      setOpenPaymentList(false);
      setOpenAddCustomerNotifier(false);
      setSelectedPaymentMethod(null);
    }
  }, [openDesktopAddCustomer]);

  useEffect(() => {
    if (selectedPaymentMethod) {
      setOpenPaymentList(false);
      setOpenAddCustomerNotifier(false);
      setOpenDesktopAddCustomer(false);
    }
  }, [selectedPaymentMethod]);

  useEffect(() => {
    if (openPaymentList) {
      setOpenAddCustomerNotifier(false);
      setSelectedPaymentMethod(null);
      setOpenDesktopAddCustomer(false);
    }
  }, [openPaymentList]);

  useEffect(() => {
    if (openAddCustomerNotifier) {
      setOpenPaymentList(false);
      setSelectedPaymentMethod(null);
      setOpenDesktopAddCustomer(false);
    }
  }, [openAddCustomerNotifier]);

  const handleSubmitSale = async (customTab) => {
    const selected_tab = customTab || selectedTab;
    setSubmitting(true);
    const sale = {
      date: new Date().toISOString(),
      items: items,
      totalPrice: totalPrice,
      cash_discount: cash_discount,
      percent_discount: percent_discount,
      customer_id: customer_id,
      payment_array: payment_array,
      is_order: selected_tab === "save_order" || selected_tab === "pay_later",
      is_paid: !selected_tab,
      tax: tax,
      delivery_charge: delivery_charge,
      organization_id: organization_id,
      branch_id: branch_id,
      note: note,
    };

    if (sale.is_order) {
      sale.payment_array = [];

      if (saleId) {
        sale.isEdit = true;
      }
    }

    setSuccessData({
      totalPrice: totalPrice,
      remainingAmount: remaining_amount,
    });

    const isOnline = await isActuallyOnline();

    if (isOnline) {
      if (saleId && !`${saleId}`.startsWith("offline")) {
        sale.id = saleId;
        convertOrderToSale(saleId, sale)
          .then((res) => {
            if (res.data.success) {
              dispatch(
                fetchSalesData({
                  organization_id: organization_id,
                  branch_id: branch_id,
                })
              );

              dispatch(deleteExistingOrder({ order: { id: saleId } }));
              if (sale.is_order && sale?.isEdit) {
                dispatch(addNewOrder({ order: res.data?.sale }));
                navigate(ROUTES.orders.path);
              } else {
                dispatch(addNewSale({ sale: res.data?.sale }));
                setStatus("success");
              }

              if (res.data?.updated_products?.length > 0) {
                dispatch(
                  updateExistingProduct({
                    products: res.data?.updated_products,
                  })
                );
              }
              setSaleID(res.data?.sale?.id);
              reloadAnalytics();
              storage.remove("cart");
              dispatch(clearCart());
              dispatch(updateLastParams());
            } else {
              setStatus("failed");
            }
          })
          .catch((err) => {
            if (sale.is_order) {
              if (err?.response?.data?.message) {
                if (err?.response?.data?.message === "User not authorized!") {
                  toast.dismiss();
                  toast.error(
                    "You do not have sufficient permissions to perform this action. Please contact your administrator."
                  );
                } else {
                  toast.dismiss();
                  toast.error(`${err?.response?.data?.message}`);
                }
              } else {
                toast.dismiss();
                toast.error("Error while editing order.");
              }
            } else {
              setStatus("failed");
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        saveSale(sale)
          .then((res) => {
            if (res.data.success) {
              dispatch(
                fetchSalesData({
                  organization_id: organization_id,
                  branch_id: branch_id,
                })
              );
              if (res.data?.updated_products?.length > 0) {
                dispatch(
                  updateExistingProduct({
                    products: res.data?.updated_products,
                  })
                );
              }
              setSaleID(res.data?.sale?.id);
              if (sale.is_order) {
                dispatch(addNewOrder({ order: res.data?.sale }));
                navigate(ROUTES.orders.path);
                toast.dismiss();
                toast.success("Order created successfully.");
              } else {
                dispatch(addNewSale({ sale: res.data?.sale }));
                reloadAnalytics();
                setStatus("success");
              }
              storage.remove("cart");
              dispatch(clearCart());
              dispatch(updateLastParams());
            } else {
              if (sale.is_order) {
                toast.dismiss();
                toast.error("Error while creating order.");
              } else {
                setStatus("failed");
              }
            }
          })
          .catch((err) => {
            if (sale.is_order) {
              if (err?.response?.data?.message) {
                if (err?.response?.data?.message === "User not authorized!") {
                  toast.dismiss();
                  toast.error(
                    "You do not have sufficient permissions to perform this action. Please contact your administrator."
                  );
                } else {
                  toast.dismiss();
                  toast.error(`${err?.response?.data?.message}`);
                }
              } else {
                toast.dismiss();
                toast.error("Error while creating order.");
              }
            } else {
              setStatus("failed");
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    } else {
      sale.created_at = new Date().toISOString();
      sale.updated_at = new Date().toISOString();
      sale.deleted_at = null;
      sale.sale_payment_methods = payment_array;
      const products = sale?.items?.map((el) => {
        const item = {
          ...el.product,
          pivot: {
            quantity: el.quantity,
            price: el?.product?.base_price,
            discount: el?.product?.discount || 0,
          },
          return: null,
        };
        return item;
      });
      sale.products = products;
      sale.customer = customer_id
        ? {
            id: customer_id,
            name: customer_name,
            phone_number: `${customer_country_code} ${customer_number}`,
            email: customer_email,
            address_line: customer_address,
            current_balance: customer_credit_amount,
            pay_later: customer_allow_pay_later,
            new: `${customer_id}`.startsWith("new") ? true : false,
          }
        : null;
      sale.user = {
        id: user_id,
        name: user_name,
        email: user_email,
      };

      sale.total_amount = totalPrice;
      sale.sale_id = "offline";
      sale.id = saleId || `offline ${Date.now()}-${user_id}`;
      sale.isConvert = `${sale.id}`.startsWith("offline") ? false : true;

      if (sale.is_order) {
        dispatch(addNewOfflineOrder({ order: sale }));
        navigate(ROUTES.orders.path);
        toast.dismiss();
        toast.success("Order created successfully.");
      } else {
        if (saleId) {
          dispatch(deleteExistingOrder({ order: { id: saleId } }));
        }
        dispatch(addNewOfflineSale({ sale: sale }));
        setStatus("success");
      }
      dispatch(clearCart());
      storage.remove("cart");
      dispatch(updateLastParams());
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (!customer_id) {
      setSelectedTab("");
    }
  }, [customer_id]);

  const reloadAnalytics = () => {
    if (analyticsLoaded) {
      dispatch(
        loadAnalytics({
          organization_id: organization_id,
          branch_id: null,
          filter_type: null,
        })
      );
    }
  };

  useEffect(() => {
    if (items?.length > 0 || payment_array?.length > 0) {
      if (remaining_amount <= 0 && Number(percent_discount) < 100) {
        handleSubmitSale();
      }
    }
  }, [remaining_amount, items, payment_array, percent_discount]);

  return (
    <div className="page-with-side-components">
      <div className="desktop-center-components">
        <div className="desktop-navbar payment-navbar box-shadow">
          <div
            className="back"
            onClick={() => {
              if (status === "failed") {
                setStatus(null);
              } else {
                navigate(ROUTES.checkout.path);
              }
            }}
          >
            <IoIosArrowBack />
          </div>
          <p>{ROUTES.payment.title}</p>
          {!status && (
            <div
              className="last-tag-svg"
              onClick={() => {
                setOpenDesktopAddCustomer(true);
              }}
            >
              <FaUser />
            </div>
          )}
        </div>
        {status ? (
          <>
            <PaymentStatus
              status={status}
              currency={currency}
              totalPrice={successData.totalPrice}
              submitting={submitting}
              handleRetry={handleSubmitSale}
              saleID={saleID}
              remainingAmount={successData.remainingAmount}
            />
            {status == "success" && (
              <div
                className="payment-navigation-back-button"
                onClick={() => {
                  navigate(ROUTES.checkout.path);
                }}
              >
                <IoIosArrowBack />
              </div>
            )}
          </>
        ) : (
          <div className="checkout-payment">
            <div className="container-wrapper payment-container">
              <div className={`amount-detail ${customer_id ? "active" : ""}`}>
                {customer_id && (
                  <>
                    <div
                      className="customer-info mobile"
                      onClick={() => {
                        navigate(ROUTES.paymentCustomer.path);
                      }}
                    >
                      <div className="user-img">
                        <FaUser />
                      </div>
                      <div className="name-number">
                        <p className="name">{customer_name}</p>
                        <p className="number">
                          {customer_country_code}
                          {customer_number}
                        </p>
                      </div>
                      <div className="swap-icon">
                        <MdSwapHorizontalCircle />
                      </div>
                    </div>
                    <div
                      className="customer-info desktop"
                      onClick={() => {
                        setOpenDesktopAddCustomer(true);
                        setOpenDesktopAddCustomerPage(false);
                      }}
                    >
                      <div className="user-img">
                        <FaUser />
                      </div>
                      <div className="name-number">
                        <p className="name">{customer_name}</p>
                        <p className="number">
                          {customer_country_code}
                          {customer_number}
                        </p>
                      </div>
                      <div className="swap-icon">
                        <MdSwapHorizontalCircle />
                      </div>
                    </div>
                  </>
                )}
                <h1 className="price">
                  <span>{currency}</span> {totalPrice}
                </h1>

                <p className="remaining">
                  Remaining Amount:{" "}
                  <span>
                    {currency}
                    {remaining_amount}
                  </span>
                </p>

                <div className={`buttons`}>
                  <button
                    className={`rounded-button ${
                      selectedTab === "save_order" ? "active" : ""
                    }`}
                    onClick={() => {
                      if (orgIsAllowedToTakeOrders.exists) {
                        handleSubmitSale("save_order");
                      } else {
                        dispatch(updateOpenSubscriptionAd({ openAd: true }));
                      }
                    }}
                  >
                    Save Order
                  </button>

                  {/* <button
                    className={`rounded-button ${
                      selectedTab === "pay_later" ? "active" : ""
                    }`}
                    onClick={() => {
                      if (selectedTab !== "pay_later") {
                        if (orgIsAllowedToTakeOrders.exists) {
                          if (customer_id && !saleId) {
                            setSelectedTab("pay_later");
                          } else {
                            setOpenAddCustomerNotifier(true);
                          }
                        } else {
                          dispatch(updateOpenSubscriptionAd({ openAd: true }));
                        }
                      } else {
                        setSelectedTab("");
                      }
                    }}
                  >
                    Pay Later
                  </button> */}
                </div>
              </div>

              <div className="payment-methods">
                <h1 className="heading" id="tour-payment-details">
                  <span className="svg">
                    <FaUserAlt />
                    <FaWallet className="wallet" />
                  </span>{" "}
                  Payment Options
                </h1>
                <div className="grid-method-list">
                  {PaymentMethods.map((item, i) => {
                    return (
                      <div
                        className={`item ${
                          Number(remaining_amount) <= 0 ? "disabled" : ""
                        }`}
                        key={i}
                        onClick={() => {
                          if (item.value === "credit") {
                            if (orgIsAllowedForStoreCredit.exists) {
                              if (customer_id) {
                                setSelectedPaymentMethod(item);
                              } else {
                                setOpenAddCustomerNotifier(true);
                              }
                            } else {
                              dispatch(
                                updateOpenSubscriptionAd({ openAd: true })
                              );
                            }
                          } else {
                            setSelectedPaymentMethod(item);
                          }
                          setOpenPaymentList(false);
                        }}
                      >
                        <p>{item.name}</p>
                        {item.icon}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="floating-button">
              <div className="buttonWrapper">
                <CustomButton
                  name={
                    selectedTab || Number(percent_discount) === 100
                      ? "Submit"
                      : "Next"
                  }
                  type={"button"}
                  color={`primary ${
                    selectedPaymentMethod ||
                    openAddCustomerNotifier ||
                    openPaymentList ||
                    openDesktopAddCustomer ||
                    openDesktopAddCustomerPage ||
                    status === "success"
                      ? "not-visible"
                      : ""
                  }`}
                  bigButton={true}
                  handleSubmit={() => {
                    if (selectedTab || Number(percent_discount) === 100) {
                      handleSubmitSale();
                    } else {
                      if (payment_array?.length > 0) {
                        setOpenPaymentList(true);
                      } else {
                        setSelectedPaymentMethod(PaymentMethods[0]);
                      }
                    }
                  }}
                  id={"tour-payment-button"}
                />
                <FaChevronRight
                  className={`sideArrow ${
                    selectedPaymentMethod ||
                    openAddCustomerNotifier ||
                    openPaymentList ||
                    openDesktopAddCustomer ||
                    openDesktopAddCustomerPage ||
                    status === "success"
                      ? "not-visible"
                      : ""
                  }`}
                />
              </div>
            </div>

            <PaymentMethod
              selectedPaymentMethod={selectedPaymentMethod}
              setSelectedPaymentMethod={setSelectedPaymentMethod}
              remaining_amount={remaining_amount}
              totalPrice={totalPrice}
              currency={currency}
              dispatch={dispatch}
              customerCreditAmount={customer_credit_amount}
              customer_id={customer_id}
              orgIsAllowedForStoreCredit={orgIsAllowedForStoreCredit}
              handleCreateSale={handleSubmitSale}
            />

            <PaymentList
              open={openPaymentList}
              setOpen={setOpenPaymentList}
              handleSubmitSale={handleSubmitSale}
              submitting={submitting}
              pamentArray={payment_array}
              currency={currency}
              dispatch={dispatch}
              remainingAmount={remaining_amount}
            />

            {/* <AddCustomerModel
              open={openAddCustomer}
              setOpen={setOpenAddCustomer}
              dispatch={dispatch}
              customer_country_code={customer_country_code}
              customer_id={customer_id}
              customer_name={customer_name}
              customer_number={customer_number}
              customer_address={customer_address}
              customer_allow_pay_later={customer_allow_pay_later}
              organization_id={organization_id}
            /> */}

            {(selectedPaymentMethod ||
              openPaymentList ||
              openAddCustomer ||
              submitting ||
              openAddCustomerNotifier ||
              openDesktopAddCustomer ||
              openDesktopAddCustomerPage) && (
              <div
                className={`blur-back ${
                  openAddCustomerNotifier ? "desktop-blur" : ""
                } ${submitting ? "active" : ""}`}
                style={submitting ? { zIndex: 1000 } : {}}
                onClick={() => {
                  selectedPaymentMethod && setSelectedPaymentMethod(null);
                  openPaymentList && setOpenPaymentList(false);
                  openAddCustomer && setOpenAddCustomer(false);
                  openAddCustomerNotifier && setOpenAddCustomerNotifier(false);
                  if (openDesktopAddCustomer) {
                    if (openDesktopAddCustomerPage) {
                      setOpenDesktopAddCustomerPage(false);
                    } else {
                      openDesktopAddCustomer(false);
                    }
                  }
                }}
              >
                {submitting && (
                  <div className="loading-sales">
                    <LuLoader2 />
                    <p>
                      Please wait. <span>Submitting the sale.</span>
                    </p>
                  </div>
                )}
              </div>
            )}

            <div className="add-customer-icon">
              {customer_id ? (
                <FaUserCog
                  onClick={() => {
                    navigate(ROUTES.paymentCustomer.path);
                  }}
                />
              ) : (
                <SlUserFollow
                  onClick={() => {
                    navigate(ROUTES.paymentCustomer.path);
                  }}
                />
              )}
            </div>

            <AddCustomerNotifier
              open={openAddCustomerNotifier}
              setOpen={setOpenAddCustomerNotifier}
              setOpenCustomer={setOpenDesktopAddCustomer}
            />
          </div>
        )}
      </div>
      {(selectedPaymentMethod ||
        openPaymentList ||
        openDesktopAddCustomer ||
        openDesktopAddCustomerPage ||
        (status === "success" && saleID)) && (
        <div
          className="right-desktop-view p-relative"
          style={
            openDesktopAddCustomer || openDesktopAddCustomerPage
              ? { zIndex: 1001 }
              : {}
          }
        >
          {!status && (
            <div className="desktop-navbar border-bottom box-shadow">
              {openDesktopAddCustomer && !openDesktopAddCustomerPage ? (
                <>
                  <div
                    className="back"
                    onClick={() => {
                      setOpenDesktopAddCustomer(false);
                    }}
                  >
                    <IoIosArrowBack />
                  </div>
                  <p>Add Customer </p>
                  {!openDesktopAddCustomerPage && (
                    <div
                      className="last-tag-svg"
                      onClick={() => {
                        setOpenDesktopAddCustomerPage(true);
                      }}
                    >
                      <FaPlus />
                    </div>
                  )}
                </>
              ) : (
                <>
                  {openDesktopAddCustomerPage && (
                    <div
                      className="back"
                      onClick={() => {
                        setOpenDesktopAddCustomerPage(false);
                      }}
                    >
                      <IoIosArrowBack />
                    </div>
                  )}
                  <p>Create New Customer</p>
                </>
              )}
            </div>
          )}
          {status && (
            <div className="desktop-navbar border-bottom box-shadow">
              <p>Sales PDF</p>
            </div>
          )}
          {openDesktopAddCustomer && !openDesktopAddCustomerPage && (
            <Customer isPayment={true} desktopView={true} />
          )}

          {openDesktopAddCustomer && openDesktopAddCustomerPage && (
            <AddCustomer isPayment={true} desktopView={true} />
          )}

          {status === "success" && <PDF id={saleID} />}
        </div>
      )}
    </div>
  );
};

export default Payment;

const AddCustomerNotifier = ({ open, setOpen, setOpenCustomer }) => {
  const navigate = useNavigate();
  return (
    <div className={`add-customer-notifier-modal ${open ? "active" : ""}`}>
      <h1>Add Customer</h1>
      <p>Customer is required for this operation.</p>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
          }}
          disabled={false}
        />
        <CustomButton
          name={"Add"}
          color={"primary mobile"}
          type={"button"}
          handleSubmit={() => {
            navigate(ROUTES.paymentCustomer.path);
          }}
          disabled={false}
        />
        <CustomButton
          name={"Add"}
          color={"primary desktop"}
          type={"button"}
          handleSubmit={() => {
            setOpenCustomer(true);
          }}
          disabled={false}
        />
      </div>
    </div>
  );
};

const PaymentMethod = ({
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  remaining_amount,
  totalPrice,
  currency,
  dispatch,
  customerCreditAmount,
  customer_id,
  orgIsAllowedForStoreCredit,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const [submitting, setSubmitting] = useState(false);

  const [remainingAmount, setRemainingAmount] = useState(remaining_amount);

  const amountWatch = watch("amount");

  const handleAddPaymentMethod = (data) => {
    if (
      selectedPaymentMethod?.value === "credit" &&
      Number(amountWatch) > Number(customerCreditAmount)
    ) {
      reset({
        amount: customerCreditAmount,
      });
    } else {
      setSubmitting(true);
      if (data.amount > 0) {
        const itemData = {
          paymentMethod: {
            label: selectedPaymentMethod.name,
            amount: Number(amountWatch),
            payment_method: selectedPaymentMethod.value,
          },
        };
        dispatch(addPaymentArray(itemData));
        toast.dismiss();
        toast.success(`Payment Added.`);
      }
      setSelectedPaymentMethod(null);
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (selectedPaymentMethod) {
      if (selectedPaymentMethod?.value === "credit") {
        if (!customer_id || !orgIsAllowedForStoreCredit.exists) {
          setSelectedPaymentMethod(null);
        } else {
          reset({
            amount:
              customerCreditAmount >= remaining_amount
                ? remaining_amount
                : customerCreditAmount,
          });
        }
      } else {
        reset({
          amount: remaining_amount,
        });
      }
      setRemainingAmount(0);
    }
  }, [selectedPaymentMethod]);

  useEffect(() => {
    setRemainingAmount((remaining_amount - Number(amountWatch)).toFixed(2));
  }, [amountWatch]);

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (selectedPaymentMethod) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [selectedPaymentMethod, isVisible]);

  if (!shouldRender) return null;

  return (
    <form
      disabled={submitting}
      onSubmit={handleSubmit(handleAddPaymentMethod)}
      className={`add-options ${isVisible ? "active" : ""}`}
    >
      <h1 className="heading">
        {selectedPaymentMethod?.icon} {selectedPaymentMethod?.name} Payment
      </h1>

      <div className="form-content">
        <div className="amount-input-container">
          <div className="title">
            <p>Amount</p>
          </div>
          <div className="main">
            <p>{currency}</p>
            <input
              type="number"
              step={"any"}
              {...register("amount", { required: true, min: 0.01 })}
            />
          </div>

          <div className="options">
            <p
              className="fix-amounts"
              onClick={() => {
                reset({ amount: 100 });
              }}
            >
              100
            </p>
            <p
              className="fix-amounts"
              onClick={() => {
                reset({ amount: 200 });
              }}
            >
              200
            </p>
            <p
              className="fix-amounts"
              onClick={() => {
                reset({ amount: 300 });
              }}
            >
              300
            </p>
            <p
              className="fix-amounts"
              onClick={() => {
                reset({ amount: remaining_amount });
              }}
            >
              Full
            </p>
          </div>
        </div>
        {/* <InputField
          name={"amount"}
          type={"number"}
          label={"Amount"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
          constraints={{
            min: 0.01,
          }}
          classNames={"highlight"}
        /> */}
        {selectedPaymentMethod?.value === "credit" &&
          Number(amountWatch) > Number(customerCreditAmount) && (
            <p className="error-message">
              Credit amount cannot be more than the user's current balance ie,{" "}
              {customerCreditAmount}
            </p>
          )}

        <p className="error-message">
          {errors?.amount?.type === "required"
            ? "Amount cannot be empty."
            : errors?.amount
            ? "Amount cannot be less than 0.01."
            : ""}
        </p>

        {Number(remainingAmount) >= 0 ? (
          <p className="details">
            Remaining Amount:{" "}
            <span className="success-texts">
              {currency}
              {remainingAmount}
            </span>
          </p>
        ) : selectedPaymentMethod?.value !== "credit" ? (
          <p className="details">
            Return Amount:{" "}
            <span className="danger-texts">
              {currency}
              {Number(remainingAmount) * -1}
            </span>
          </p>
        ) : (
          <></>
        )}

        <p className="details small">
          Total:{" "}
          <span className="navy-texts">
            {currency}
            {totalPrice}
          </span>
        </p>
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setSelectedPaymentMethod(null);
          }}
          disabled={submitting}
        />

        <CustomButton
          name={"Next"}
          color={"primary"}
          type={"submit"}
          handleSubmit={() => {}}
          disabled={
            submitting ||
            (selectedPaymentMethod?.value === "credit" &&
              Number(amountWatch) > Number(customerCreditAmount))
          }
          loader={submitting}
        />
      </div>
    </form>
  );
};

const PaymentList = ({
  open,
  setOpen,
  submitting,
  handleSubmitSale,
  pamentArray,
  currency,
  dispatch,
  remainingAmount,
}) => {
  const handleRemovePaymentMethod = (data) => {
    const itemData = {
      paymentMethod: { ...data },
    };

    dispatch(removeFromPaymentArray(itemData));
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;

  return (
    <div className={`add-options payment-list ${isVisible ? "active" : ""}`}>
      <h1 className="heading">
        <FaScroll /> Payment List
      </h1>

      <div className="form-content list">
        {pamentArray.map((item, i) => {
          return (
            <div className="payemnt-item" key={i}>
              <p>
                {item?.label}:{" "}
                <span>
                  {currency}
                  {item?.amount}
                </span>
              </p>
              <FaTrash
                onClick={() => {
                  handleRemovePaymentMethod(item);
                }}
              />
            </div>
          );
        })}
      </div>

      <div className="buttons list">
        {Number(remainingAmount) === 0 && (
          <CustomButton
            name={"Cancel"}
            color={"danger"}
            type={"button"}
            handleSubmit={() => {
              setOpen(false);
            }}
            disabled={submitting}
          />
        )}
        <CustomButton
          name={"Submit"}
          color={Number(remainingAmount) === 0 ? "dark full-width" : "dark"}
          type={"button"}
          handleSubmit={handleSubmitSale}
          disabled={submitting || Number(remainingAmount) > 0}
          loader={submitting}
        />

        {Number(remainingAmount) !== 0 && (
          <CustomButton
            name={"Select More"}
            color={"primary"}
            type={"button"}
            handleSubmit={() => {
              setOpen(false);
            }}
            disabled={submitting}
          />
        )}
      </div>
    </div>
  );
};

const AddCustomerModel = ({
  open,
  setOpen,
  dispatch,
  customer_name,
  customer_address,
  customer_allow_pay_later,
  customer_number,
  customer_country_code,
  customer_id,
  organization_id,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const [submitting, setSubmitting] = useState(false);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    label: "",
    value: "",
  });

  const phoneWatch = watch("customer_number");

  const handleAddCustomer = (data) => {
    setSubmitting(true);
    const customerData = {
      name: data.customer_name,
      phone_number: `${selectedOption?.value} ${data.customer_number}`,
      organization_id: organization_id,
    };

    addNewCustomer(customerData)
      .then((res) => {
        if (res.data) {
          const user = res.data;
          const userData = {
            customer_name: data.customer_name,
            customer_number: data.customer_number,
            customer_country_code: selectedOption?.value,
            customer_id: user?.id,
            customer_address: data.customer_address,
            customer_allow_pay_later: data.customer_allow_pay_later,
            customer_credit_amount: Number(user?.current_balance).toFixed(2),
          };
          dispatch(updatePaymentCustomerDetails(userData));
          toast.dismiss();
          toast.success("Customer Added Successfully");
          setOpen(false);
        }
      })
      .catch((err) => {
        toast.dismiss();
        toast.error("Error while adding customer.");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleClearCustomer = () => {
    dispatch(clearPaymentCustomerDetails());
    toast.dismiss();
    toast.success("Customer data removed.");
    setOpen(false);
  };

  const searchCustomer = () => {
    if (phoneWatch) {
      setSubmitting(true);
      let phone_number = `${selectedOption?.value} ${phoneWatch}`;
      fetchCustomers(phone_number, organization_id)
        .then((res) => {
          if (res.data?.length) {
            const customerData = res.data[0];

            const customerDetails = {
              customer_name: customerData?.name,
              customer_number: phoneWatch,
              customer_country_code: selectedOption?.value,
              customer_id: customerData?.id,
              customer_address: customerData?.customer_address,
              customer_allow_pay_later: customerData?.customer_allow_pay_later,
              customer_credit_amount: Number(
                customerData?.current_balance
              ).toFixed(2),
            };

            reset({
              customer_name: customerData?.name,
              customer_address: customerData?.customer_address,
              customer_allow_pay_later: customerData?.customer_allow_pay_later,
            });

            dispatch(updatePaymentCustomerDetails(customerDetails));
            toast.dismiss();
            toast.success("Customer details updated.");
            setOpen(false);
          }
        })
        .catch((err) => {
          toast.dismiss();
          toast.error("Couldnot find the customer.");
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      toast.dismiss();
      toast.error("Phone number is empty.");
    }
  };

  useEffect(() => {
    const selectOptions = [];
    CountryCodes.forEach((item) => {
      selectOptions.push({
        label: `${item.flag}(${item.country_code})`,
        value: item.country_code,
      });
    });

    setSelectedOption(selectOptions[0]);
    setOptions(selectOptions);
  }, []);

  useEffect(() => {
    if (open) {
      reset({
        customer_name: customer_name,
        customer_address: customer_address,
        customer_number: customer_number,
        customer_allow_pay_later: customer_allow_pay_later,
        customer_country_code: customer_country_code,
      });

      let selected = options.find((el) => el.value === customer_country_code);
      if (selected) {
        setSelectedOption(selected);
      }
    }
  }, [open]);

  return (
    <form
      disabled={submitting}
      onSubmit={handleSubmit(handleAddCustomer)}
      className={`add-options add-customer ${open ? "active" : ""}`}
    >
      <h1 className="heading">
        <HiUserAdd /> Add Customer
      </h1>

      <div className="form-content list">
        <div className="select-and-input">
          <InputField
            name={"customer_number"}
            type={"number"}
            label={"Phone Number"}
            required={true}
            register={register}
            inputErrors={errors}
            watch={watch}
            disabled={customer_id !== null}
          />
          <div className="select-wrapper">
            <InputSelect
              options={options}
              value={selectedOption}
              register={register}
              required={false}
              name="customer_country_code"
              handleChange={(opt) => {
                setSelectedOption(opt);
              }}
              reset={reset}
              label={""}
              inputErrors={errors}
              disabled={customer_id !== null}
            />
          </div>
          <div
            className={`search-input ${customer_id ? "" : "active"}`}
            onClick={searchCustomer}
          >
            <FiSearch />
          </div>
        </div>

        <InputField
          name={"customer_name"}
          type={"text"}
          label={"Customer Name"}
          required={true}
          register={register}
          inputErrors={errors}
          watch={watch}
          disabled={customer_id !== null}
        />

        <InputField
          name={"customer_address"}
          type={"text"}
          label={"Address Line(Optional)"}
          required={false}
          register={register}
          inputErrors={errors}
          watch={watch}
          disabled={customer_id !== null}
        />

        <ToggleSwitch
          name={"customer_allow_pay_later"}
          label={"Allow customer to pay later"}
          register={register}
          required={false}
          showSVG={false}
          disabled={customer_id !== null}
        />
      </div>

      <div className="buttons">
        <CustomButton
          name={"Close"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
          }}
          disabled={submitting}
        />

        {customer_id && (
          <CustomButton
            name={"Clear Customer"}
            color={"dark"}
            type={"button"}
            handleSubmit={handleClearCustomer}
            disabled={submitting}
            loader={submitting}
          />
        )}

        {!customer_id && (
          <CustomButton
            name={"Add Customer"}
            color={"primary"}
            type={"submit"}
            handleSubmit={() => {}}
            disabled={submitting}
            loader={submitting}
          />
        )}
      </div>
    </form>
  );
};
